import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export class PublicationPeriod {
  fromPublicationDate: string;
  toPublicationDate: string;
}

@Injectable({
  providedIn: 'root',
})
export class SearchEventService {
  query$ = new BehaviorSubject('');
  page$: BehaviorSubject<number> = new BehaviorSubject(1);
  service$ = new BehaviorSubject('');
  pillar$ = new BehaviorSubject('');
  documentType$ = new BehaviorSubject('');
  region$ = new BehaviorSubject('');
  publicationPeriod$ = new BehaviorSubject(null);
  //toPublicationDate$ = new BehaviorSubject('');
  //queryObservable$=this.query$.asObservable();

  constructor() {}

  emitSearchQueryEvent(query: string) {
    if (this.query$.getValue() !== query) {
      this.query$.next(query);
    }
  }
}
